var URL = "/";
var URL_MOCK = "/mock";
export var PATH_GET_NEWS = URL_MOCK + "/news";